import { render } from "./Producten.vue?vue&type=template&id=2475420a&scoped=true&ts=true"
import script from "./Producten.vue?vue&type=script&lang=ts"
export * from "./Producten.vue?vue&type=script&lang=ts"

import "./Producten.vue?vue&type=style&index=0&id=2475420a&scoped=true&lang=css"

import exportComponent from "/tmp/nginx/vue-single-page-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2475420a"]])

export default __exports__